import React from 'react'
import { FormattedMessage } from 'react-intl'
import PageTitle from '../PageTitle'
import { ListingConsumer, ListingProvider } from '../../context/ListingContext'
import DraftsList from './DraftsList'
import { LanguageConsumer } from '../../context/LanguageContext'
import TemplatesList from './TemplatesList'

const DraftsPageContent = ({ entityName }) => {
  return (
    <ListingProvider entityName={entityName}>
      <ListingConsumer>
        {({ listingData, openDialog }) => (
          <>
            <PageTitle
              title={<FormattedMessage id={`${entityName || 'drafts'}PageContent.PageTitle`}/>}
              invoice
              singleInvoice
            />
            <LanguageConsumer>
              {({ locale }) => (
                {
                  'drafts': <DraftsList listingData={listingData} locale={locale} openDialog={openDialog}/>,
                  'templates': <TemplatesList listingData={listingData} locale={locale} openDialog={openDialog}/>
                }[entityName] || ''
              )}
            </LanguageConsumer>
          </>
        )}
      </ListingConsumer>
    </ListingProvider>
  )
}

export default DraftsPageContent
